import tw from 'twin.macro';

// for timetable
export const InvRow = tw.div`mx-auto  py-2 md:py-4 lg:py-6
 w-full px-4 lg:w-11/12 lg:flex border-b border-gray-300 last:border-none lg:justify-between`;

export const Details = tw.div`lg:text-xl md:flex md:justify-center text-sm font-semibold`;

export const DetailItem = tw.div`lg:my-1`;
